var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cc-loader"},[_c('img',{attrs:{"src":"/images/loader.svg"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_txt),expression:"show_txt"}]},[_vm._v(_vm._s(_vm.text || 'Carregando'))])])}
var staticRenderFns = []

export { render, staticRenderFns }